var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{staticClass:"flex-grow-0"},[_c('v-progress-circular',{staticClass:"justify-center",attrs:{"indeterminate":"","color":"#7F8080","size":"48","width":"5"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }